<template>
  <div class="mt-1">
    <div
      class="d-flex justify-content-end mt-2 mb-3"
      style="gap: 10px"
    >
      <b-button
        :disabled="!formLoaded"
        class="btn btn--create btn--smaller"
        type="button"
        variant="primary"
        size="sm"
        @click="openUploadDocument"
        title="Carica un nuovo documento"
        v-if="canVerb(resource, 'store')"
      >
        <base-icon name="circled_plus" width="22" height="22" />
        Crea</b-button
      >
    </div>
    <table-document
      :isTableInModal="true"
      :fields="fields"
      @destroy="deleteDocument"
      :repository="repository"
      :resource="resource"
      :filterName="filterName"
      :ref="tableRef"
      :onlyActions="['destroy']"
      noInnerWidth
      @download="downloadDocument"
    >
    </table-document>
    <add-document-modal
      v-if="formLoaded"
      :beFormCreate="beForm[repository]"
      :beRulesCreate="beRules[repository]"
      @upload="uploadDocument"
    >
    </add-document-modal>
  </div>
</template>

<script>
import TableDocument from "@/components/tables/Documents";
import AddDocumentModal from "@/components/modals/addDocument";
import FormMixin from "@/mixins/FormMixin";
import BaseIcon from "@/components/BaseIcon";
import DetailTabAutofetchTableMixin from "@/mixins/DetailTabAutofetchTableMixin";
import DocumentsMixin from "@/mixins/DocumentsMixin";
import { toLocaleDate } from "@/utils/dates";

export default {
  mixins: [FormMixin, DetailTabAutofetchTableMixin, DocumentsMixin],
  name: "Documents",
  data() {
    return {
      filter: this.initFilter(),
      formLoaded: false,
      filterName: "filterClaimDocumentsDetail",
      repository: "document",
      resource: "documents",
      tableRef: "claimDocumentsDetailTableRef",
      relation: "claim",
      fields: [
        {
          key: "title",
          label: this.getDictionary("title", "document"),
          sortable: false,
          sortKey: "title",
        },
        {
          key: "note",
          label: this.getDictionary("note", "document"),
          sortable: false,
          sortKey: "note",
        },
        {
          key: "extension",
          label: this.getDictionary("source_type", "document"),
          sortable: false,
          sortKey: "extension",
        },
        {
          key: "document_type.text",
          label: this.getDictionary("document_type", "document"),
          sortable: false,
          sortKey: "document_type.text",
        },
        {
          key: "created_at",
          label: this.getDictionary("created_at", "document"),
          sortable: false,
          formatter: (value) =>
            value ? toLocaleDate(value, "DD/MM/YYYY HH:mm:ss") : "-",
        },
        {
          key: "download",
          label: this.getDictionary("Scarica Documento"),
          tdClass: "text-center",
          thStyle: {
            width: "125px",
          },
        },
      ],
    };
  },
  components: {
    BaseIcon,
    TableDocument,
    AddDocumentModal,
  },
  methods: {
    toLocaleDate,
    initFilter() {
      let init = {
        byClaim: { id: this.resourceId },
      };
      return init;
    },
    openUploadDocument() {
      this.$bvModal.show("addDocumentModal");
    },
  },
  props: {
    resourceId: Number,
  },
  beforeMount() {
    this.fetchCreateForm(this.repository)
      .then(() => {
        this.formLoaded = true;
      })
      .catch((error) => {
        console.error(error);
      });
  },
};
</script>
